"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var React = __importStar(require("react"));
var react_1 = require("react");
var modal_1 = __importDefault(require("../../../plugins/modal"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
var utils_1 = require("../../account-v3/utils");
var app_1 = require("../app");
var nav_1 = __importDefault(require("../components/nav"));
var page_1 = __importDefault(require("../components/page"));
var quantity_picker_1 = __importDefault(require("../components/quantity-picker"));
var is_variant_available_1 = __importDefault(require("../is-variant-available"));
var buildChoicesWithPotentialTag = function (possibleVariantsForSizeQuantity, printsTagList, tag) {
    return possibleVariantsForSizeQuantity.map(function (variant) {
        if (!tag)
            return { variant: variant };
        var shouldGetTag = printsTagList.some(function (config) {
            return config.patternName.toUpperCase() === variant.option2.toUpperCase() && config.size.toUpperCase() === variant.option1.toUpperCase();
        });
        if (shouldGetTag)
            return { variant: variant, tag: tag };
        return { variant: variant };
    });
};
var useContext = React.useContext, useMemo = React.useMemo, useState = React.useState;
var SelectPrints = function (_a) {
    var enableNighttimeDiapers = _a.enableNighttimeDiapers, possibleChoices = _a.possibleChoices, possibleNighttimeChoices = _a.possibleNighttimeChoices, settings = _a.settings;
    var _b = __read(useState(null), 2), openModalVariant = _b[0], setOpenModalVariant = _b[1];
    var _c = __read(useState(true), 2), allPatternsActive = _c[0], setAllPatternsActive = _c[1];
    var _d = __read(useState(false), 2), nighttimePatternsActive = _d[0], setNighttimePatternsActive = _d[1];
    var _e = __read(useState(), 2), accordion = _e[0], setAccordion = _e[1];
    var printsSortListRaw = settings.printsSortList, printsTagListRaw = settings.printsTagList, printsTagText = settings.printsTagText, printsTagDescription = settings.printsTagDescription;
    var context = useContext(app_1.AppContext);
    if (!context)
        return null;
    var currentSubStepIdx = context.currentSubStepIdx, handleAddPattern = context.handleAddPattern, handleToggleChoiceClick = context.handleToggleChoiceClick, handleSubPattern = context.handleSubPattern, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, handleExpandedMobileLayoutSetup = context.handleExpandedMobileLayoutSetup, selBundleType = context.selBundleType, selChoices = context.selChoices, selSizeQuantities = context.selSizeQuantities, setSelChoices = context.setSelChoices, shouldHideLowStockItems = context.shouldHideLowStockItems, existingBundle = context.existingBundle;
    var selChoicesIds = useMemo(function () { return selChoices.map(function (v) { return v.id; }); }, []);
    var activeSizeQuantity = selSizeQuantities[currentSubStepIdx];
    if (!activeSizeQuantity)
        return null;
    // how many prints must be selected before being allowed to move on? default 1
    var minNumPrintsRequired = settings.minNumPrints || 1;
    (0, react_1.useEffect)(function () {
        if (isTestingExpandedMobileLayout) {
            // again, we need to set a timeout to wait for to get the height for the scroll window in instances where overflow expands for nighttime diaper accordions
            setTimeout(function () {
                handleExpandedMobileLayoutSetup();
            }, 1500);
        }
    }, [accordion]);
    (0, react_1.useEffect)(function () {
        var _a;
        var sortedSizes = ['N', '1', '2', '3', '4', '5', '6', '12-24M', '2T-3T', '3T-4T', '4T-5T'];
        var sortedSelSizeQuantities = __spreadArray([], __read(selSizeQuantities), false).sort(function (a, b) { return sortedSizes.indexOf(a === null || a === void 0 ? void 0 : a.size) - sortedSizes.indexOf(b === null || b === void 0 ? void 0 : b.size); });
        // There is a strange issue we're seeing in GA where we get two of the same size on both bundlers. I want to test if this fixes it.
        if (sortedSelSizeQuantities[0] && sortedSelSizeQuantities[1] && sortedSelSizeQuantities[0].size === sortedSelSizeQuantities[1].size) {
            sortedSelSizeQuantities = [sortedSelSizeQuantities[0]];
        }
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__prints', sizes: sortedSelSizeQuantities });
    }, []);
    (0, react_1.useEffect)(function () {
        setAccordion(new Foundation.Accordion($('#patterns')));
    }, []);
    var printsSortList = useMemo(function () { return (printsSortListRaw === null || printsSortListRaw === void 0 ? void 0 : printsSortListRaw.toUpperCase().split('\n')) || []; }, []);
    var sortChoices = function (choices, opts) {
        return choices
            .filter(function (variant) {
            // make sure that the choice is the right size
            if (variant.option1 !== activeSizeQuantity.size)
                return false;
            // don't show unavailable variants unless forced
            if (!(opts === null || opts === void 0 ? void 0 : opts.forceAvailibility) && !(0, is_variant_available_1.default)(variant))
                return false;
            // don't show low-stock items if item is low and setting is activated
            if (!(opts === null || opts === void 0 ? void 0 : opts.forceAvailibility) && shouldHideLowStockItems && (0, utils_1.isVariantLowStock)(variant))
                return false;
            // for training pants sizes...
            if ((0, app_1.getProductTypeForSize)(variant.option1) === 'TrainingPants') {
                var isMixedBundleVariant = variant.name.includes('(Mixed)');
                // don't show certain variants for mixed bundles (they might be $1 upcharge)
                if (selBundleType === 'Mixed' && !isMixedBundleVariant)
                    return false;
                // don't show other variants for training pants-only bundles
                if (selBundleType === 'TrainingPants' && isMixedBundleVariant)
                    return false;
            }
            return true;
        })
            .sort(function (a, b) {
            if (selChoicesIds.includes(a.id))
                return -1; // if a is selected, move it up
            if (selChoicesIds.includes(b.id))
                return 1; // if b is selected, move it up
            if ((0, utils_1.isVariantLowStock)(a))
                return 1; // if a is low stock, move it down
            if ((0, utils_1.isVariantLowStock)(b))
                return -1; // if b is low stock, move it down
            // for patterns in the sort list, show them in order
            var indexA = printsSortList.indexOf(a.option2.toUpperCase());
            var indexB = printsSortList.indexOf(b.option2.toUpperCase());
            if (indexA >= 0 && indexB === -1)
                return -1;
            if (indexB >= 0 && indexA === -1)
                return 1;
            if (indexA >= 0 && indexB >= 0)
                return indexA < indexB ? -1 : 1;
            // otherwise order them by newest variants first
            return a.id < b.id ? 1 : -1;
        });
    };
    var printsTagList = useMemo(function () {
        var e_1, _a;
        if (!printsTagListRaw)
            return [];
        var lines = printsTagListRaw.toUpperCase().split('\n');
        var configs = [];
        try {
            for (var lines_1 = __values(lines), lines_1_1 = lines_1.next(); !lines_1_1.done; lines_1_1 = lines_1.next()) {
                var line = lines_1_1.value;
                var _b = __read(line.split(':'), 2), patternName = _b[0], size = _b[1];
                if (!patternName || !size)
                    continue;
                configs.push({ patternName: patternName.trim(), size: size.trim() });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (lines_1_1 && !lines_1_1.done && (_a = lines_1.return)) _a.call(lines_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return configs;
    }, [printsTagListRaw]);
    // primary could be daytimes or training pants
    var possiblePrimaryVariantsForSizeQuantity = useMemo(function () { return sortChoices(possibleChoices || []); }, [activeSizeQuantity]);
    var possiblePrimaryChoicesForSizeQuantity = useMemo(function () { return buildChoicesWithPotentialTag(possiblePrimaryVariantsForSizeQuantity, printsTagList, printsTagText); }, [possiblePrimaryVariantsForSizeQuantity, printsTagList, printsTagText]);
    var possibleNighttimeVariantsForSizeQuantity = useMemo(function () { return sortChoices(possibleNighttimeChoices || [], { forceAvailibility: !!existingBundle || settings.showOosNighttimes }); }, [activeSizeQuantity]);
    var possibleNighttimeChoicesForSizeQuantity = useMemo(function () { return buildChoicesWithPotentialTag(possibleNighttimeVariantsForSizeQuantity, printsTagList, printsTagText); }, [possibleNighttimeVariantsForSizeQuantity, printsTagList, printsTagText]);
    var aChoiceHasTag = useMemo(function () { return possiblePrimaryChoicesForSizeQuantity.some(function (choice) { return choice.tag; }) || possibleNighttimeChoicesForSizeQuantity.some(function (choice) { return choice.tag; }); }, [possiblePrimaryChoicesForSizeQuantity, possibleNighttimeChoicesForSizeQuantity]);
    var nighttimeDiapersAllowedForSize = enableNighttimeDiapers && possibleNighttimeChoicesForSizeQuantity.length > 0;
    var activeSelChoices = useMemo(function () { return selChoices.filter(function (v) { return v.option1 === activeSizeQuantity.size; }); }, [selChoices]);
    var numUniquePrintsSelected = useMemo(function () { return (0, uniqBy_1.default)(activeSelChoices, function (c) { return c.id; }).length; }, [activeSelChoices]);
    var gridStyle = 'grid-x small-up-2 medium-up-3 grid-margin-x grid-margin-y';
    var handleCloseModalClick = function () { return setOpenModalVariant(null); };
    var handleOpenModalClick = function (variant) { return function () { return setOpenModalVariant(variant); }; };
    var headerText = "".concat(settings.header).concat(selSizeQuantities.length > 1 ? " - Size ".concat(activeSizeQuantity.size) : '');
    // simply an array of PatternLimit objects for each choice
    // this is used to determine if there are are any limited patterns in activeSelChoices
    var limitedPatternsForChoices = useMemo(function () {
        return activeSelChoices.map(function (choice) { return (0, app_1.getPatternLimit)(choice); });
    }, [activeSelChoices]);
    // non-limited means there is no limited setting for the pattern
    var hasNonLimitedPattern = limitedPatternsForChoices.some(function (pattern) { return pattern === undefined; });
    var hasLimitedPattern = limitedPatternsForChoices.some(function (pattern) { return pattern !== undefined; });
    var limitedPatternsCanProceed = useMemo(function () {
        // can proceed only if we have at least one non-limited pattern to be re-balanced later, we have zero limited patterns, or we have picked the maximum amount of choices
        return !hasLimitedPattern || hasNonLimitedPattern || activeSelChoices.length >= activeSizeQuantity.quantity;
    }, [limitedPatternsForChoices]);
    var pageNav = (React.createElement(nav_1.default, { afterNext: function () {
            // if the user has not selected all choices, allocate the remainder here
            if (activeSelChoices.length < activeSizeQuantity.quantity) {
                var newSelChoices = (0, app_1.rebalancePrints)({
                    existingChoices: selChoices,
                    numNewChoices: activeSizeQuantity.quantity - activeSelChoices.length,
                    eligibleNewChoices: activeSelChoices.filter(function (choice) { return !(0, app_1.getPatternLimit)(choice); }),
                });
                setSelChoices(newSelChoices);
            }
        }, 
        // if the user has selected enough prints than required or available
        // (because some sizes may have, for example, only 2 patterns available when the requirement is 3)
        canGoNext: limitedPatternsCanProceed && (numUniquePrintsSelected >= minNumPrintsRequired || numUniquePrintsSelected >= activeSizeQuantity.quantity), centerContent: React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'large-price lh1 font-bold' },
                settings.useBooleanPicking ? numUniquePrintsSelected : activeSelChoices.length,
                React.createElement("span", { className: 'font-normal h4 padding-horizontal-2' }, "of"),
                activeSizeQuantity.quantity),
            React.createElement("div", { className: 'text-nobel margin-top-1' },
                React.createElement("small", null, settings.navCenterText))) }));
    var generatePatternsForGrid = function (patterns, _a) {
        var _b = _a === void 0 ? {} : _a, treatLowStockAsOutOfStock = _b.treatLowStockAsOutOfStock;
        return (React.createElement(React.Fragment, null, patterns.map(function (pattern) {
            var _a;
            var variant = pattern.variant;
            var numSelected = activeSelChoices.filter(function (_a) {
                var id = _a.id;
                return id === variant.id;
            }).length;
            var isLowStock = (0, utils_1.isVariantLowStock)(variant);
            return (React.createElement(quantity_picker_1.default, { limitedQty: (_a = (0, app_1.getPatternLimit)(variant)) === null || _a === void 0 ? void 0 : _a.qtyLimit, limitedQtyTooltipText: !existingBundle ? settings.patternQtyLimitTooltipText : undefined, key: variant.id, addChoice: handleAddPattern(variant), bundleType: 'diaper', isAvailable: (0, is_variant_available_1.default)(variant) && (!treatLowStockAsOutOfStock || !isLowStock), isLowStock: isLowStock, numSelected: numSelected, setModalChoice: handleOpenModalClick(variant), subChoice: handleSubPattern(variant), toggleChoice: handleToggleChoiceClick(variant), variant: variant, useBooleanPicking: settings.useBooleanPicking, tag: pattern.tag }));
        })));
    };
    var buttonStyle = function (buttonActive) { return (buttonActive ? { backgroundColor: '#e8d9ed' } : { backgroundColor: '#f1f1f1' }); };
    var headerTextVariables = (function () {
        if (selBundleType !== 'Mixed')
            return { productType: null };
        return { productType: (0, app_1.getProductTypeForSize)(activeSizeQuantity.size) === 'Diapers' ? 'Diaper' : 'Training Pants' };
    })();
    // edge case for inventory quantity reservation
    // this content will display when an existing bundler edits their designs but none are available on their next ship date
    var unavailablePatternsContent = (React.createElement("div", { className: 'text-center bg-almost-white padding-10 padding-vertical-20' },
        React.createElement("h6", null, settings.sizesOOSHeader),
        React.createElement("div", { className: 'divider bg-light-wisteria margin-vertical-3 margin-horizontal-auto' }),
        React.createElement("div", null, settings.sizesOOSBody)));
    return (React.createElement(page_1.default, { renderNav: pageNav },
        React.createElement("div", { className: 'bundler-app-select-prints padding-6 medium-padding-10 large-padding-horizontal-14 large-padding-vertical-8' },
            React.createElement("div", { className: 'flex-container align-justify' },
                React.createElement("div", { className: 'flex-child-shrink' },
                    React.createElement("h3", null, (0, replace_section_variables_1.default)(headerText, headerTextVariables)))),
            React.createElement("div", { className: 'margin-bottom-6' },
                React.createElement("div", { className: 'font-lighter' }, (function () {
                    if (selBundleType === 'Mixed')
                        return settings.mixedSubheader;
                    if (selBundleType === 'TrainingPants')
                        return settings.trainingPantsSubheader;
                    return settings.subheader;
                })()),
                React.createElement("div", { className: 'h-4' }),
                aChoiceHasTag && printsTagText && printsTagDescription && (React.createElement("div", { className: 'flex-container align-top', style: { columnGap: '0.75em', rowGap: '0.25em', flexWrap: 'wrap' } },
                    React.createElement("div", { className: 'bundler-app-quantity-picker--tag', style: { userSelect: 'none', flexShrink: 0 } }, printsTagText),
                    React.createElement("div", { className: 'tag-key-description font-size-14 font-lighter', style: { flexBasis: 475 }, dangerouslySetInnerHTML: { __html: printsTagDescription } })))),
            nighttimeDiapersAllowedForSize && settings.showNighttimeBanner && (React.createElement("div", { className: 'grid-x padding-horizontal-5 padding-vertical-3 margin-bottom-6', style: { backgroundColor: '#5f5bab', maxHeight: '100px' } },
                React.createElement("span", { className: 'small-3 medium-1' },
                    React.createElement("img", { src: settings.nighttimeBannerImage, style: { width: '75px' } })),
                React.createElement("span", { className: 'small-9 medium-11 padding-left-2' },
                    React.createElement("div", { className: 'text-night-time' }, settings.nighttimeBannerHeader),
                    React.createElement("div", { className: 'text-white', style: { fontSize: '12px' } }, settings.nighttimeBannerBody)))),
            (function () {
                // if we are allowed to see nighttime sizes, show them and daytimes
                if (nighttimeDiapersAllowedForSize) {
                    return possiblePrimaryChoicesForSizeQuantity.length > 0 || possibleNighttimeChoicesForSizeQuantity.length > 0 ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: 'grid-x' },
                            React.createElement("div", { className: 'small-1' },
                                React.createElement("div", { className: 'button rounded padding-horizontal-5', style: buttonStyle(allPatternsActive), onClick: function () {
                                        $('#patterns').foundation('down', $('#daytime'));
                                        $('#patterns').foundation('down', $('#nighttime'));
                                        setNighttimePatternsActive(false);
                                        setAllPatternsActive(true);
                                    } },
                                    React.createElement("span", { className: allPatternsActive ? 'text-wisteria' : 'text-nobel' }, "All"))),
                            React.createElement("div", { className: 'small-11' },
                                React.createElement("div", { className: 'margin-left-15 button rounded padding-horizontal-5', style: buttonStyle(nighttimePatternsActive), onClick: function () {
                                        $('#patterns').foundation('up', $('#daytime'));
                                        $('#patterns').foundation('down', $('#nighttime'));
                                        setNighttimePatternsActive(true);
                                        setAllPatternsActive(false);
                                    } },
                                    React.createElement("span", { className: nighttimePatternsActive ? 'text-wisteria' : 'text-nobel' }, "Nighttime Diapers")))),
                        React.createElement("hr", null),
                        React.createElement("div", null,
                            React.createElement("ul", { id: 'patterns', className: 'accordion', "data-accordion": true, "data-multi-expand": 'true', "data-allow-all-closed": 'true' },
                                React.createElement("li", { className: 'accordion-item is-active', "data-accordion-item": true },
                                    React.createElement("a", { href: '#daytime', className: 'accordion-title' },
                                        React.createElement("h4", null, "Daytime Diapers")),
                                    React.createElement("div", { id: 'daytime', className: 'accordion-content', "data-tab-content": true },
                                        React.createElement("div", { className: 'font-lighter padding-bottom-5', dangerouslySetInnerHTML: { __html: settings.daytimeSubheader } }),
                                        React.createElement("div", { className: gridStyle, "data-accordion-item": true }, generatePatternsForGrid(possiblePrimaryChoicesForSizeQuantity)))),
                                React.createElement("hr", null),
                                React.createElement("li", { className: 'is-active', "data-accordion-item": true },
                                    React.createElement("a", { href: '#nighttime', className: 'accordion-title' },
                                        React.createElement("h4", null, "Nighttime Diapers")),
                                    React.createElement("div", { id: 'nighttime', className: 'accordion-content', "data-tab-content": true },
                                        React.createElement("div", { className: 'font-lighter padding-bottom-5', dangerouslySetInnerHTML: { __html: settings.nighttimeSubheader } }),
                                        existingBundle && hasLimitedPattern && settings.nighttimeSubtext && (React.createElement("div", { className: 'font-lighter', dangerouslySetInnerHTML: { __html: settings.nighttimeSubtext } })),
                                        React.createElement("div", { className: gridStyle }, generatePatternsForGrid(possibleNighttimeChoicesForSizeQuantity, { treatLowStockAsOutOfStock: !existingBundle })))))))) : (unavailablePatternsContent);
                }
                // else show daytime sizes only
                return possiblePrimaryChoicesForSizeQuantity.length > 0 ? (React.createElement("div", { className: gridStyle, "data-accordion-item": true }, generatePatternsForGrid(possiblePrimaryChoicesForSizeQuantity))) : (unavailablePatternsContent);
            })(),
            React.createElement(modal_1.default, { isOpen: !!openModalVariant, handleClose: handleCloseModalClick }, (function () {
                var _a;
                if (!openModalVariant) {
                    return null;
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'flex-container align-justify padding-top-4 padding-horizontal-4' },
                        React.createElement("div", { className: 'flex-child-shrink' }, openModalVariant.option2)),
                    React.createElement("img", { alt: "photo of ".concat(openModalVariant.option2), src: (_a = openModalVariant.featured_image) === null || _a === void 0 ? void 0 : _a.src, className: 'display-block width-100', style: { maxWidth: '75rem' } })));
            })()))));
};
exports.default = SelectPrints;
